export default __webpack_public_path__ + "static/all-2d018a0e3251845d61f7fa6dde1efb50.jpg";